export default {
  checking: 'Preparing verification…',
  verification: 'Verifying with World ID…',
  authorization: 'Getting claim authorization…',
  walletConfirmation: 'Waiting for World App confirmation…',
  transactionSubmitted: 'Submitting transaction…',
  enrollmentTransactionTitle: 'Authorizing claim wallet…',
  enrollmentTransactionDescription: 'Confirm the BBG claim wallet authorization in World App.',
  transactionTitle: 'Claiming BBG…',
  transactionDescription: 'Sending the {{amount}} BBG claim transaction in World App.',
  success: 'Claim successful.',
  notProvided: 'Not provided',
  yes: 'Yes',
  no: 'No',
  diagnosticCode: 'Diagnostic code',
  errorCode: 'World ID error code',
  maskedAppId: 'App ID (masked)',
  maskedRpId: 'RP ID (masked)',
  firstVerification: 'First verification',
  proofReturned: 'Proof returned',
  backendVerifyAttempted: 'Backend verification attempted',
  title: 'Human verification · Daily claim',
  close: 'Close daily claim window',
  todayReward: 'Today’s reward',
  claimed: 'Claimed',
  nextClaim: 'Next claim available: {{time}}',
  login: 'Sign in with World App first to claim BBG.',
  worldAppOnly: 'This feature is available only inside the World App Mini App.',
  diagnostic: 'Diagnostic code: {{value}}',
  flow: 'Flow: {{value}}',
  sessionProof: 'Session Proof verification',
  firstVerificationFlow: 'First verification',
  transport: 'Transport: {{value}}',
  worldAppPlatform: 'World App platform: {{value}}',
  miniKitVerify: 'MiniKit Verify: {{value}}',
  confirmedViewWorldscan: 'Claim transaction confirmed: View on Worldscan',
  claim: 'Claim {{amount}} BBG',
  debugOnly: 'DEVELOPMENT ONLY',
  debugTitle: 'IDKit Debug',
  closeDebug: 'Close IDKit Debug',
  safeDiagnosticNote: 'Only allowlisted diagnostic data that is safe to share with engineers is shown below.',
  copySafeDiagnostic: 'Copy safe diagnostic data',
  copiedDiagnostic: 'Safe diagnostic data copied',
  copyUnsupported: 'Copy is not supported here. Read the panel contents directly.',
} as const;
